module.exports = __webpack_public_path__ + "img/charles.6e5917f8.jpg";